'use client';

import { useState } from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Alignable,
    Headline,
    HeadlineLevel,
    HeadlineMarkup,
    Text,
    TextMarkup,
} from '@bytel/trilogy-react-ts';

import { MobileAndFaiFaqType } from '../forfaits-mobiles/sans-engagement/page';

export function Faq({ faqs, isMobilePlan }: { faqs?: MobileAndFaiFaqType; isMobilePlan: boolean }) {
    const [canShowMore, setCanShowMore] = useState<boolean>(false);
    const items = isMobilePlan ? faqs?.mobileFaq : faqs?.faiFaq;

    if (!items) return null;
    return (
        <>
            <div className='container is-fluid mt-5 mb-5'>
                <Headline
                    className='has-text-centered has-text-blue-byou'
                    typo={Alignable.ALIGNED_CENTER}
                    markup={HeadlineMarkup.H2}
                    level={HeadlineLevel.LEVEL3}
                >
                    Vos questions fréquentes <br />
                    sur les {isMobilePlan ? 'forfaits' : 'offres'} B&YOU
                </Headline>
                <div className='columns is-multiline is-centered'>
                    <div className='column'>
                        <section>
                            <Accordion>
                                {items.map((item, index) => (
                                    <AccordionItem
                                        id={'id' + index}
                                        key={item.question}
                                        className={index > 5 && !canShowMore ? 'is-hidden' : ''}
                                    >
                                        <AccordionHeader className='has-text-weight-semibold' toggle>
                                            {item.question}
                                        </AccordionHeader>
                                        <AccordionBody>
                                            <Text
                                                markup={TextMarkup.SPAN}
                                                className='has-text-justified'
                                                htmlContent={item.answer}
                                            />
                                        </AccordionBody>
                                    </AccordionItem>
                                ))}
                            </Accordion>

                            {items.length > 5 ? (
                                <div className='has-text-centered mt-2 pt-4'>
                                    <a
                                        className='button-clear link'
                                        onClick={() => setCanShowMore(!canShowMore)}
                                        aria-label='questions'
                                    >
                                        {canShowMore ? 'Moins de questions' : 'Voir les autres questions'}
                                    </a>
                                </div>
                            ) : null}
                        </section>
                    </div>
                </div>
            </div>
        </>
    );
}
